export const normalizeGerman = (str: string): string => {
  return str
      // Only replace if it's likely meant as an umlaut replacement:
      .replace(/\bue/g, 'ü')     // Word-starting 'ue' → ü
      .replace(/([b-df-hj-np-tv-z])ue/g, '$1ü') // consonant + ue → ü
      .replace(/\boe/g, 'ö')
      .replace(/([b-df-hj-np-tv-z])oe/g, '$1ö')
      .replace(/\bae/g, 'ä')
      .replace(/([b-df-hj-np-tv-z])ae/g, '$1ä')
      .replace(/ss/g, 'ß');
};

export const stemGermanWord = (word: string): string => {
  return word.toLowerCase();
};
